import { FC } from 'react'
import styled, { css } from 'styled-components'
import { getLimitNumText } from 'components/ActivityListCardItem/module/getLimitNumText'

interface TeamRecruitBadgeProps {
  teamRecruitPostCount: number
}

const TeamRecruitBadge: FC<TeamRecruitBadgeProps> = ({
  teamRecruitPostCount,
}) => {
  return (
    <StyledWrapper>
      <span>팀원 모집</span>
      <span className="recruit-post-count">
        {getLimitNumText({
          number: teamRecruitPostCount,
          limit: 99,
        })}
      </span>
    </StyledWrapper>
  )
}

export default TeamRecruitBadge

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    height: 24px;
    display: flex;
    border-radius: 3px;
    padding: 5px;
    background-color: #0132ff;
    opacity: 0.9;
    color: ${theme.background.bg_8};
    font-weight: bold;
    font-size: 10px;

    .recruit-post-count {
      margin-left: 1px;
      color: #ffd800;
    }
  `}
`
